<script setup lang="ts">
import { Card, CardTitle, CardContent, CardFooter } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import { globalActor } from "@/machines/globalMachine"

async function goToStepper() {
  globalActor.send({ type: "GLOBAL.GUEST.STEPPER" })
}
</script>

<template>
  <div class="container flex justify-center">
    <Card
      class="flex items-center justify-center border-pink-200 text-center lg:w-[500px]"
    >
      <FaIcon icon="fat fa-clock-rotate-left" class="text-pink h-10 w-10" />
      <CardTitle as="h1" class="text-grey-darken-1">
        {{ $t("assessment.iframe.restart.title") }}
      </CardTitle>

      <Separator class="bg-grey-lighten-3 w-[180px]!" />

      <CardContent
        class="flex flex-col items-center gap-4 py-0 text-sm md:text-base"
      >
        <p class="text-grey-darken-1 text-center font-sans">
          {{ $t("assessment.iframe.restart.body") }}
        </p>
      </CardContent>

      <CardFooter>
        <Button
          class="bg-pink hover:bg-pink-darken-1 w-full md:w-auto"
          @click="goToStepper"
        >
          {{ $t("general.back_button") }}
        </Button>
      </CardFooter>
    </Card>
  </div>
</template>
